const Environments = ["local", "dev", "prod"] as const;
type Environment = (typeof Environments)[number];

interface Context {
  env: Environment;
  apiEndpoint: string;
  userPoolId: string;
  userPoolClientId: string;
  s3Bucket: string;
  s3BucketRegion: string;
  publicAssetsBaseUrl: string;
}

const contexts: Record<Environment, Context> = {
  local: {
    env: "local",
    apiEndpoint: "http://localhost:3000",
    userPoolId: "us-west-2_PJfbcr1da",
    userPoolClientId: "2rmahh2pji0b66p56slu9frnnf",
    s3Bucket: "canna42-public-assets-dev",
    s3BucketRegion: "us-west-2",
    publicAssetsBaseUrl: "https://assets.dev.canna42.com",
  },
  dev: {
    env: "dev",
    apiEndpoint: "https://api.dev.canna42.com",
    userPoolId: "us-west-2_PJfbcr1da",
    userPoolClientId: "2rmahh2pji0b66p56slu9frnnf",
    s3Bucket: "canna42-public-assets-dev",
    s3BucketRegion: "us-west-2",
    publicAssetsBaseUrl: "https://assets.dev.canna42.com",
  },
  prod: {
    env: "prod",
    apiEndpoint: "https://api.canna42.com",
    userPoolId: "us-west-2_UpxW5CXqU",
    userPoolClientId: "5th8jmoupt8o01q75uh9i1chd2",
    s3Bucket: "cannapedia-public-assets-prod",
    s3BucketRegion: "us-west-2",
    publicAssetsBaseUrl: "https://assets.canna42.com",
  },
};

function inferEnvFromUrl(): Environment {
  const url = new URL(window.location.href);
  const host = url.host;

  switch (host) {
    case "localhost:3001":
      return "local";
    case "admin.dev.canna42.com":
      return "dev";
    case "admin.canna42.com":
      return "prod";
    default:
      throw new Error(`Unknown environment for host: ${host}`);
  }
}

function getContext(): Context {
  const env = inferEnvFromUrl();
  return contexts[env];
}

export const context = getContext();
